module.exports = __webpack_public_path__ + "static/media/Preya.0f21acd4.png";